import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './styles.module.scss';

type ShimmerContainerProps = {
  children?: ReactNode;
  className?: string;
  isInactive?: boolean;
};

export default function ShimmerContainer({ children, className, isInactive }: ShimmerContainerProps) {
  return (
    <div className={classNames(styles.container, className)}>
      {children}
      {isInactive ? null : <div className={styles.ripple} />}
    </div>
  );
}
